enum CommercialProductsApiSuffixModule {
 COMMERCIAL_PORDUCTS = "commercial-products"
}

export { CommercialProductsApiSuffixModule }